import { CSSProperties, FC } from 'react';

import { Box, List, ListItem } from '@mui/material';
import { clsx } from 'clsx';

import { STYLE_VARIANTS } from 'components/OnePageTemplates/interfaces/variants';

import { DoughnutChart, LegendLabel } from './components';
import { useGetFundingNeedsChartData } from './helpers/getFundingNeedsChartData';
import { IFundingDirectionChart } from './types';

import styles from './FundingDirectionChart.module.scss';

export const FundingDirectionChart: FC<IFundingDirectionChart> = ({
  classes,
  data,
  title,
  variant = STYLE_VARIANTS.CONTAINED,
  renderLegendLabel,
}) => {
  const isOutlined = variant === STYLE_VARIANTS.OUTLINED;
  const displayData = useGetFundingNeedsChartData(data, isOutlined);

  return (
    <Box className={clsx(styles.innerWrapper, classes?.root)}>
      {title}
      <Box className={styles.chartWrapper}>
        <DoughnutChart data={displayData} className={clsx(styles.chart, classes?.chart)} />
        <List className={styles.listWrapper}>
          {displayData.map(({ title, percentage, color }) => {
            const cssVariables = {
              '--chart-color': color,
            } as CSSProperties;

            return (
              <ListItem className={styles.listItem} key={title} style={cssVariables}>
                <LegendLabel title={title} percentage={percentage} render={renderLegendLabel} />
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
};
